import type { ModelItem, ModelListParams, ModelListResponse } from '@/types/model'
import type { BackendFavoriteItem } from '@/types/userCenter/modelApiTypes'
/**
 * Favorites API - V2
 * @description 收藏相关API
 */
import { httpClient } from '@/utils/request'

const BASE_URL = '/users/me/favorites'

/**
 * 获取收藏列表
 * 适配后端结构 {"data": models, "count": count}，并适配成组件 ModelItem
 */
export async function getFavorites(params: ModelListParams = {}): Promise<ModelListResponse> {
  const page = params.page || 1
  const pageSize = params.pageSize || 20

  // 按照和后端一致的设计转换参数 (`page` 跟 `pageSize` 后端都支持, 不过为了稳健我们传 `page` / `size` 作为 fallback)
  const queryParams: Record<string, string | number> = { page, pageSize }
  // 注意：在此忽略 keyword 等未支持参数

  const res = await httpClient.get<{ data: BackendFavoriteItem[], count: number }>(BASE_URL, { params: queryParams })

  return {
    list: res.data.map((item: BackendFavoriteItem) => ({
      id: String(item.id),
      title: item.title,
      name: item.title,
      description: item.description,
      category: item.category_l1_code,
      tags: item.tags || [],
      formats: item.formats || item.fileFormats || [],
      fileFormats: item.formats || item.fileFormats || [],
      software: item.software || '',
      softwareVersion: item.software_version || item.softwareVersion || '',
      price: item.price,
      isFree: item.is_free ?? item.isFree,
      status: item.status,
      createdAt: item.created_at || item.createdAt,
      updatedAt: item.updated_at || item.updatedAt,
      coverImage: item.cover_image || item.coverImage,
      imageUrl: item.cover_image || item.coverImage || '',
      images: item.images,
      format: item.format || '',
      downloadCount: item.download_count || 0,
      favoriteCount: item.favorite_count || 0,

      // 附加前端用来渲染喜欢的专属托底属性
      isCollected: true,
      favoritedAt: item.favoritedAt,
    } as ModelItem)),
    total: res.count,
    page,
    pageSize,
  }
}

/**
 * 添加收藏
 */
export async function addFavorite(modelId: string): Promise<void> {
  return httpClient.post<void>(BASE_URL, { modelId })
}

/**
 * 取消收藏
 */
export async function removeFavorite(modelId: string): Promise<void> {
  return httpClient.delete<void>(`${BASE_URL}/${modelId}`)
}
